import { styled } from '@mui/material/styles';
import { Box, Card } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default,
  padding: theme.spacing(4),
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 800,
  margin: '0 auto',
}));

export const Header = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

export const ProfileCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(4),
  borderRadius: theme.spacing(2),
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  marginBottom: theme.spacing(3),
}));

export const AvatarSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  marginBottom: theme.spacing(4),
  paddingBottom: theme.spacing(3),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const InfoRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  '&:last-child': {
    borderBottom: 'none',
  },
}));

export const InfoLabel = styled(Box)(({ theme }) => ({
  flex: '0 0 180px',
  color: theme.palette.text.secondary,
  fontWeight: 500,
}));

export const InfoValue = styled(Box)(({ theme }) => ({
  flex: 1,
  color: theme.palette.text.primary,
}));
